import { rng } from '@/data/statsData';
import { cn } from '@/lib/utils';

// Drawn camera frame of the conveyor: stones on the belt, one branch, the detection box.
export const BranchFrame = ({ finding, label }) => {
  const r = rng(Number(finding.id.slice(2)) * 31);
  const stones = Array.from({ length: 28 }, () => ({ x: r() * 100, y: 18 + r() * 64, s: 2 + r() * 4 }));
  const { x, y, w, h, angle } = finding.box;
  const alarm = finding.outcome !== 'false';
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full aspect-video rounded-md bg-stone-300" role="img" aria-label={label}>
      <rect x="0" y="15" width="100" height="70" className="fill-stone-400" />
      {stones.map((s, i) => <ellipse key={i} cx={s.x} cy={s.y} rx={s.s} ry={s.s * 0.7} className="fill-stone-200" />)}
      <rect x={x + 2} y={y + h / 2 - 1} width={w - 4} height="2" rx="1" transform={`rotate(${angle} ${x + w / 2} ${y + h / 2})`} className="fill-amber-800" />
      <rect x={x} y={y} width={w} height={h} fill="none" strokeWidth="0.8" className={cn(alarm ? 'stroke-red-500' : 'stroke-amber-400')} strokeDasharray={alarm ? '' : '2 1'} />
      <rect x={x} y={y - 6} width="22" height="5" className={alarm ? 'fill-red-500' : 'fill-amber-400'} />
      <text x={x + 1} y={y - 2.4} fontSize="3.4" className="fill-white font-semibold">{label} {finding.confidence} %</text>
    </svg>
  );
};
